"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["INBOUND_RECEIVED"] = "Inbound.Received";
    EventType["INBOUND_SHIPMENT_STATUS_CHANGED"] = "Inbound.ShipmentStatusChanged";
    EventType["INVENTORY_ADJUSTED"] = "Inventory.Adjusted";
    EventType["ORDER_SHIPPED"] = "Order.Shipped";
    EventType["RETURN_INSPECTED"] = "Return.Inspected";
    EventType["RETURN_RECEIVED"] = "Return.Received";
    EventType["RETURN_SHIPMENT_RECEIVED"] = "Return.ShipmentReceived";
    EventType["RETURN_SHIPPED"] = "Return.Shipped";
    EventType["RETURN_UPDATED"] = "Return.Updated";
    EventType["WHOLESALE_SHIPMENT_STATUS_CHANGED"] = "Wholesale.ShipmentStatusChanged";
    EventType["FREIGHT_TRACKING_UPDATED"] = "Freight.TrackingUpdated";
    EventType["PARCEL_TRACKING_UPDATED"] = "Parcel.TrackingUpdated";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=EventType.js.map